<template>
  <div style="display: inline-block;">
    <b-btn
      v-b-tooltip.hover
      title="Histórico"
      variant="none"
      class="btn-none icone-acao m-0 p-0"
      @click="openModalHistorico(gridProps)"
    >
      <font-awesome-icon
        icon="fa-sharp fa-solid fa-list"
        class="text-primary"
      />
    </b-btn>

    <atualizacao-manual
      tipo-rotina="DTE"
      :enviar-atualizacao="atualizarDTE"
      :disabled="!abilityUpdate"
      :title-tooltip="abilityUpdate ? 'Atualizar a DTE' : 'Usuário não possui permissão'"
      @atualizar-grid="$emit('atualizar-grid')"
    />

    <modal-historico
      :ref="`modalHistorico${gridProps.row.id}`"
      rotina="DTE"
      des-de="Outubro de 2025"
      :empresa="gridProps.row"
      :api="apiDTE"
      :coluna-historico="colunaHistorico"
      :filtros-rapidos="filtrosRapidos"
      :filtro-by-historico="['ConsultadoEm']"
      :acoes-lote="{ downloadExcel: true }"
      :somente-visualizacao="true"
    />

    <loading
      :show-cancel-button="false"
      :is-loading="isLoading"
      :titulo-carregamento="'Aguarde!'"
      descricao="Estamos atualizando a DTE."
    />
  </div>
</template>

<style lang="scss">
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { abilityValidation } from '@/auth/utils'
import colunasHistorico from '../historico'
import api from '../../services/api'

export default {
  components: {
    FontAwesomeIcon,
    ModalHistorico: () => import('@/app/shared/components/historico/ModalHistorico.vue'),
    Loading: () => import('@pilar/components/loading/Loading.vue'),
    AtualizacaoManual: () => import('@/app/shared/components/botoes-inline/atualizacao-manual/AtualizacaoManual.vue'),
  },
  props: {
    gridProps: {
      type: Object,
      required: true,
    },
    filtrosRapidos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      abilityUpdate: abilityValidation(32, 3),
      colunaHistorico: colunasHistorico,
      apiDTE: api,
      isLoading: false,
    }
  },
  methods: {
    notificarErro(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'fa-solid fa-circle-exclamation',
          variant: 'danger',
        },
      })
    },
    notficarSucesso(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'fa-solid fa-circle-check',
          variant: 'success',
        },
      })
    },
    atualizarGrid() {
      this.$emit('atualizar-grid')
    },
    openModalHistorico(props) {
      this.$set(props.row, 'statusAlterado', false)
      this.$refs[`modalHistorico${props.row.id}`].abrirModal()
    },
    atualizarDTE() {
      return api.updateDTE(this.gridProps.row.empresaId)
    },
  },
}
</script>
